module.exports = __webpack_public_path__ + "img/ogp_kiwen_big.1b659058.jpg";